// Editable Product Links here
// var productLinks = {
//     '111': 'link-a-producto-espresso-2x250-mensual',
//     '112': 'link-a-producto-espresso-2x250-6meses',
//     '121': 'link-a-producto-espresso-4x250-mensual',
//     '122': 'link-a-producto-espresso-4x250-6meses',
//     '211': 'link-a-producto-filtro-2x250-mensual',
//     '212': 'link-a-producto-filtro-2x250-6meses',
//     '221': 'link-a-producto-filtro-4x250-mensual',
//     '222': 'link-a-producto-filtro-4x250-6meses',
//     '311': 'link-a-producto-mix-2x250-mensual',
//     '312': 'link-a-producto-mix-2x250-6meses',
//     '321': 'link-a-producto-mix-4x250-mensual',
//     '322': 'link-a-producto-mix-4x250-6meses'
// };

$("#subscription-button-proceed").on("click", function (event) {
  event.preventDefault(); // Prevent the default anchor behavior

  var productLink = $(this).attr("href"); // Get the href attribute value

  if (productLink) {
    window.open(productLink, "_blank"); // Open the link in a new tab
  }
});

var websiteHost = "https://" + jQuery(location).attr("hostname") + "/products/";

var selectedValues = {
  question1: "",
  question2: "",
  question3: "",
};

jQuery("#question-1").addClass("visible");

function scrollToElement(element) {
  $("html, body").animate(
    {
      scrollTop: $(element).offset().top - 20,
    },
    800
  );
}

$("#choice").on("click", function () {
  scrollToElement("#subscritiom-intro");
});

$(".subscription-answers .subscription-answer").on("click", function () {
  var $this = $(this);
  var questionNumber = $this.closest(".subscription-question").data("question");
  var answerValue = $this.index() + 1;

  selectedValues["question" + questionNumber] = answerValue;

  $this.siblings().removeClass("active");
  $this.addClass("active");

  if (questionNumber == 1 && selectedValues.question1) {
    $("#question-2").addClass("visible").fadeIn();
    scrollToElement("#question-2");
  } else if (questionNumber == 2 && selectedValues.question2) {
    $("#question-3").addClass("visible").fadeIn();
    scrollToElement("#question-3");
  }

  if (
    selectedValues.question1 &&
    selectedValues.question2 &&
    selectedValues.question3
  ) {
    var combinedValue =
      selectedValues.question1 +
      "" +
      selectedValues.question2 +
      "" +
      selectedValues.question3;
    var productLink = productLinks[combinedValue];

    if (productLink) {
      var fullUrl = websiteHost + productLink;
      $("#subscription-button-proceed").attr("href", fullUrl);
    }

    $(".proceed").addClass("visible").fadeIn();
    scrollToElement(".proceed");
  }
});
